import * as React from 'react';
import classNames from 'classnames';
import { formatPhone } from '../rifmRecipes/phone';
import { VerificationCode } from '../verificationCode/verificationCode';
import HiddenLabel from '../accessibility/HiddenLabel';
import {
  SCodeSection,
  SPopup,
  SSubtitle,
  SCenteredSubtitle,
  SCodeNotReceivedSection,
  SCodeNotReceivedButton,
  SCodeNotReceivedTimer } from './PinCodeStyle';
import Title from '../onlineTitle/Title';

// ############################ Imported from Old UI ###########################

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IVerifyState {
  phoneNumber: string;
  verificationCode: string;
}

export interface IPincodeProps {
  onChange: (value: string | boolean, name: string) => void;
  submit: (verifyState: Partial<IVerifyState>) => void;
  clearTimerInterval: () => void;
  resetTimer: () => void;
  countDown: number;
  phone?: string;
  verificationCode?: string;
  error?: boolean;
  long?: boolean;
  noLightBox?: boolean;
  onClose?: () => void;
  className?: string;
  handleVerificationCodeNotReceived: () => void;
}

export default class PinCodeSms extends React.Component<IPincodeProps> {
  private pinLength = this.props.long ? 6 : 4;

  public state = {
    verificationCode: '',
  };

  private handleSubmit = async (verificationCode: string) => {
    const { submit } = this.props;

    await submit({
      phoneNumber: this.props.phone,
      verificationCode: verificationCode,
    });
  };

  private verificationCodeFilled = async (verificationCode: string) => {
    await this.setState({ verificationCode });
    await this.props.onChange(verificationCode, 'verificationCode');
    if (verificationCode.length === this.pinLength) {
      await this.handleSubmit(verificationCode);
    }
  };

  private closeModal = () => {
    const { onClose, clearTimerInterval, resetTimer, onChange } = this.props;
    clearTimerInterval();
    resetTimer();
    onChange(false, 'openPincodePopup');

    onClose?.();
  };

  private handleVerificationCodeNotReceived = () => {
    this.closeModal();
    this.props.handleVerificationCodeNotReceived();
  }

  private getCountDownText = () => {
    const { countDown } = this.props;

    const secondsRemaining = Math.floor(countDown % 60);
    const secondsRemainingText = secondsRemaining
      ? secondsRemaining < 10
        ? `0${secondsRemaining}`
        : secondsRemaining
      : '00';
    return `(${Math.floor(countDown / 60)}:${secondsRemainingText})`;
  };

  private getPopupFooter = () => {
    const timeRemaining = this.props.countDown;
    const { long } = this.props;

    return (
      <div className="footer">
        <SCenteredSubtitle alignLeft={false} dataAt="pincodeHelper">
          <span>It may take up to 60 seconds for the verification code to arrive.</span>
          <br />
          <br />
        </SCenteredSubtitle>
        <SSubtitle dataAt="pincodeSubtitle" className={long ? 'long-pincode-subtitle' : ''}>
          <HiddenLabel
            label={
              timeRemaining > 0
                ? 'Verification process may take up to 60 seconds. Did not get a verification code?'
                : ''
            }
          />
          <SCodeNotReceivedSection onClick={() => (!timeRemaining) ? this.handleVerificationCodeNotReceived() : undefined }>
            <SCodeNotReceivedButton isActive={!timeRemaining}>Didn't receive a verification code? </SCodeNotReceivedButton>
            <SCodeNotReceivedTimer>{this.getCountDownText()}</SCodeNotReceivedTimer>
          </SCodeNotReceivedSection>
        </SSubtitle>
      </div>
    );
  }

  public render() {
    const { noLightBox, long, className } = this.props;
    const popupFooter = this.getPopupFooter();

    return (
      <SPopup
        noLightBox={noLightBox}
        hidePopupButton={true}
        dataAt="pincode-popUp"
        onClose={this.closeModal}
        className={classNames(className, { 'long-pincode-popup': long })}
      >
        <Title data-at="verificationCodeHeader">Enter the code sent to you at</Title>
        <Title data-at="phoneNumber">{formatPhone(this.props.phone || '')}</Title>
        <SCodeSection id="VerificationCode">
          <VerificationCode
            error={this.props.error}
            value={this.props.verificationCode}
            onFilled={this.verificationCodeFilled}
            length={this.pinLength}
          />
        </SCodeSection>
        {popupFooter}
      </SPopup>
    );
  }
}
